// Fired on window when the server answered 401 signed_in_elsewhere inside the
// RF shell (rf.html), which has no login route to send the tab to: the API
// client raises it, RfApp listens, signs the operator out and shows the reason
// on its login screen. Its own module so an RF test that mocks the client
// (vi.mock('@/shared/api/client')) still has it.
export const SESSION_LOST_EVENT = 'erp:session-lost';
